module.exports = __webpack_public_path__ + "static/media/MarcioMoretto.602ea523.png";